import React, { useState, useRef } from 'react';
import sprite from '../../../static/sprite.svg';
import './Navbar.scss';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import Button from '../Button/Button';
import { useEffect } from 'react';

const Navbar = () => {
  const [isDropdownOneOpen, setIsDropdownOneOpen] = useState(false);
  const [isDropdownTwoOpen, setIsDropdownTwoOpen] = useState(false);
  const [isDropdownThreeOpen, setIsDropdownThreeOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const dropdownOneRef = useRef();
  const dropdownTwoRef = useRef();
  const dropdownThreeRef = useRef();

  const onClickOutside = TYPE => {
    if (TYPE === 'TWO') setIsDropdownTwoOpen(false);
    else setIsDropdownThreeOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        isDropdownTwoOpen &&
        dropdownTwoRef.current &&
        !dropdownTwoRef.current.contains(event.target)
      ) {
        onClickOutside('TWO');
      }
      if (
        isDropdownThreeOpen &&
        dropdownThreeRef.current &&
        !dropdownThreeRef.current.contains(event.target)
      ) {
        onClickOutside('THREE');
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  const dropdownOneHandler = () => {
    setIsDropdownTwoOpen(false);
    setIsDropdownThreeOpen(false);
    setIsDropdownOneOpen(state => !state);
  };

  const dropdownTwoHandler = () => {
    setIsDropdownOneOpen(false);
    setIsDropdownThreeOpen(false);
    setIsDropdownTwoOpen(state => !state);
  };

  const dropdownThreeHandler = () => {
    setIsDropdownOneOpen(false);
    setIsDropdownTwoOpen(false);
    setIsDropdownThreeOpen(state => !state);
  };

  const hamburgerHandler = () => {
    setShowMenu(state => !state);
  };

  const location = useLocation();
  const bottomContainerRef = useRef();
  console.log(location);

  useEffect(() => {
    if (window.innerWidth > 1024) setShowMenu(true);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar__top-row">
        <div className="navbar__logo-box">
          <Link to="/">
            <svg className="navbar__logo">
              <use href={`${sprite}#logo`} />
            </svg>
          </Link>
        </div>
        <button className="navbar__hamburger-menu" onClick={hamburgerHandler}>
          <svg className="navbar__hamburger-icon">
            <use href={`${sprite}#${showMenu ? 'cross' : 'hamburger'}`} />
          </svg>
        </button>
      </div>

      <div
        className="navbar__bottom-row"
        ref={bottomContainerRef}
        // style={{
        //   height: showMenu
        //     ? `${+bottomContainerRef.current.scrollHeight + 53}px`
        //     : '0',
        // }}
        style={{
          display: showMenu ? 'flex' : 'none',
        }}
      >
        <div className="navbar__menu">
          <div className="navbar__links">
            <ul className="navbar__list navbar__list--1">
              <li className="navbar__list-item ">
                <Link to="/" activeClassName="navbar__list-item--active">
                  <span className="navbar__link">home</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link to="/about" activeClassName="navbar__list-item--active">
                  <span className="navbar__link">about us</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link
                  to="/our-partners"
                  activeClassName="navbar__list-item--active"
                >
                  <span className="navbar__link">our partners</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link
                  to="/patient-stories"
                  activeClassName="navbar__list-item--active"
                >
                  <span className="navbar__link">Patient Stories</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link
                  to="/nominate-a-patient"
                  activeClassName="navbar__list-item--active"
                >
                  <span className="navbar__link">Nominate a Patient</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link to="/join-us" activeClassName="navbar__list-item--active">
                  <span className="navbar__link">Join Us</span>
                </Link>
              </li>
              <li className="navbar__list-item">
                <Link to="/donate" activeClassName="navbar__list-item--active">
                  <span className="navbar__link">Donate</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <div className="navbar__dropdowns">
            <ul className="navbar__list navbar__list--2">
              <li className="navbar__list-item">
                <div
                  onClick={dropdownThreeHandler}
                  className={`navbar__dropdown-text ${
                    ['/donate', '/help'].indexOf(location.pathname) !== -1
                      ? 'navbar__list-item--active'
                      : ''
                  }`}
                >
                  <span className="navbar__link">join us</span>
                  <span className="navbar__icon-box">
                    <svg className="navbar__icon">
                      <use href={`${sprite}#down-arrow`} />
                    </svg>
                  </span>
                </div>
                <div
                  className="navbar__options-container"
                  ref={dropdownThreeRef}
                  style={{
                    height: isDropdownThreeOpen
                      ? `${dropdownThreeRef.current.scrollHeight}px`
                      : '0',
                  }}
                >
                  <div className="navbar__options-wrapper">
                    <Link to="/help">
                      <span className="navbar__option">Join Us</span>
                    </Link>
                    <Link to="/donate">
                      <span className="navbar__option">Donate</span>
                    </Link>
                  </div>
                </div>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
      {/* <div className="navbar__btn-box">
        <Button label="Donate" buttonStyle="PRIMARY" type="button" />
      </div> */}
    </nav>
  );
};

export default Navbar;
